import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ErrorMessage } from '../../interfaces/error-message.interface';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { getErrorLevelString } from '../../enums/error-level.enum';
import { getErrorTypeString } from '../../enums/error-type.enum';
import { Project } from 'src/app/project/shared/interfaces/project.interface';
import { ProjectGroup } from 'src/app/project/shared/interfaces/project-group.interface';
import { ProjectRouteStation } from 'src/app/project/shared/interfaces/project-route-station.interface';

@Component({
  selector: 'avs-error-messages-table',
  standalone: false,
  templateUrl: './error-messages-table.component.html',
  styleUrl: './error-messages-table.component.css'
})
export class ErrorMessagesTableComponent implements OnInit {
  displayedColumns: string[] = [/* 'id', */ 'projectId', 'groupId', 'samId', 'deKanal', 'localBusAdress', 'errorType', 'errorLevel', 'describtion', 'from', 'to', 'errorSolved'];
  dataSource?: MatTableDataSource<ErrorMessage>;
  getErrorLevelString = getErrorLevelString;
  getErrorTypeString = getErrorTypeString;

  @Input() public errorMessages: ErrorMessage[] = [];
  @Input() public projects: Project[] = [];
  @Input() public groups: ProjectGroup[] = [];
  @Input() public routeStations: ProjectRouteStation[] = [];

  @ViewChild(MatPaginator) paginator?: MatPaginator;
  @ViewChild(MatSort) sort?: MatSort;

  constructor() { }

  public ngOnInit(): void {
    this.dataSource = new MatTableDataSource(this.errorMessages);
    if (this.paginator)
      this.dataSource!.paginator = this.paginator;
    if (this.sort)
      this.dataSource!.sort = this.sort;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource!.filter = filterValue.trim().toLowerCase();

    if (this.dataSource!.paginator) {
      this.dataSource!.paginator.firstPage();
    }
  }

  getProjectName(projectId: number): string {
    const project = this.projects.find(p => p.id === projectId);
    return project ? project.name : '';
  }

  getGroupName(groupId: number): string {
    const group = this.groups.find(g => g.id === groupId);
    return group ? group.name : '';
  }

  getDeviceName(samId: number): string {
    const routeStation = this.routeStations.find(rs => rs.samId === samId);
    return routeStation ? routeStation.name : '';
  }
}
